import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center w-100 h-100" }
const _hoisted_2 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_3 = ["disabled", "title", "onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled", "onClick", "title"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["disabled", "title", "onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "d-flex flex-row flex-wrap gap-1"
}
const _hoisted_13 = {
  key: 0,
  class: "d-flex flex-row"
}
const _hoisted_14 = ["onClick", "title"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick", "title"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "d-flex flex-row"
}
const _hoisted_21 = ["onClick", "title"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "d-none" }
const _hoisted_25 = { class: "d-none" }
const _hoisted_26 = { class: "d-flex flex-row flex-wrap gap-1 align-items-center" }
const _hoisted_27 = { class: "d-flex flex-column gap-1 align-self-start deputyLoopParentDiv" }
const _hoisted_28 = { class: "d-flex flex-row" }
const _hoisted_29 = ["disabled", "title", "onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)
const _hoisted_33 = ["disabled", "title", "onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["disabled", "title", "onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-return-left" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 0,
  class: "d-flex flex-row flex-wrap gap-1"
}
const _hoisted_40 = { class: "d-flex flex-row flex-wrap" }
const _hoisted_41 = ["disabled", "title", "onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle" }, null, -1)
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "d-flex flex-row flex-wrap alert alert-danger" }
const _hoisted_47 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_48 = { class: "d-flex flex-row flex-wrap" }
const _hoisted_49 = ["disabled", "title", "onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar-date" }, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["disabled", "title", "onClick"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope" }, null, -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = ["disabled", "title", "onClick"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_57 = [
  _hoisted_56
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectParticipationRestrictionWidget = _resolveComponent("ProjectParticipationRestrictionWidget")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DeputyAddDropdown = _resolveComponent("DeputyAddDropdown")!
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!
  const _component_ProjectParticipantHistoryPartListWidget = _resolveComponent("ProjectParticipantHistoryPartListWidget")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ParticipationDeleteWidget = _resolveComponent("ParticipationDeleteWidget")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ParempiGrid, {
      class: "flex-grow-1 flex-min-height-0 projectParticipationListWidget",
      columns: this.columns,
      rowPosFactory: this.rowPosFactory,
      rowPosIncrementor: this.rowPosIncrementor,
      items: this.organisationParticipationInfos,
      filterString: _ctx.quickFilter,
      ref: "grid",
      idGetter: (organisationParticipationInfo) => organisationParticipationInfo.organisation.id,
      storageKey: "projectParticipationListWidget",
      andFilter: ""
    }, {
      actions: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (this.securityInfo.mayEmailParticipation)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.participation.list.organisation.mail'),
                  onClick: ($event: any) => (_ctx.openEmailPage('participation', item.participationInfos.map(p => p.projectParticipation.id)))
                }, _hoisted_5, 8, _hoisted_3))
              : _createCommentVNode("", true),
            (this.securityInfo.mayEditParticipation)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-primary",
                  onClick: ($event: any) => (_ctx.edit(item)),
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.participation.list.organisation.edit')
                }, _hoisted_8, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (this.securityInfo.mayDeleteParticipation)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-danger",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.participation.list.organisation.delete'),
                  onClick: (() => {
                            return () => _ctx.deleteParticipationByOrganisation(item);
                            })()
                }, _hoisted_11, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      subProjects: _withCtx(({ item, rowPos }) => [
        (!item.withSubProjectRestrictions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getAllowedSubProjects(item, rowPos), (allowedSubProject) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: allowedSubProject.id,
                  class: "d-flex flex-row flex-wrap gap-1 align-self-start"
                }, [
                  _createElementVNode("span", null, _toDisplayString(allowedSubProject.code) + _toDisplayString(allowedSubProject.number ?? "") + " " + _toDisplayString(allowedSubProject.name), 1)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(_component_ProjectParticipationRestrictionWidget, {
              key: 1,
              disabled: this.disabled,
              participationInfo: this.getParticipationInfo(item, rowPos),
              editInfo: this.editInfo,
              securityInfo: this.securityInfo
            }, null, 8, ["disabled", "participationInfo", "editInfo", "securityInfo"]))
      ]),
      subProjectsHeaderWrapper: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          "data-bs-toggle": "tooltip",
          title: _ctx.$t('project.participation.edit.allowedSubProjectsTooltip')
        }, null, 8, ["title"]))
      ]),
      comment: _withCtx(({ item, rowPos, info = _ctx.getParticipationInfo(item, rowPos) }) => [
        (this.securityInfo.mayEditParticipation && _ctx.commentEditParticipationId == info.projectParticipation.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_TextInput, {
                class: "",
                modelValue: this.commentEditRawComment,
                mode: "flex",
                ref: _ctx.getParticipationCommentInputRef(info),
                onKeydown: _ctx.keydown
              }, null, 8, ["modelValue", "onKeydown"]),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-primary ms-1",
                onClick: ($event: any) => (_ctx.saveComment(info)),
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('general.save')
              }, _hoisted_16, 8, _hoisted_14),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-danger ms-1",
                onClick: ($event: any) => (_ctx.abortEditComment(info)),
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('general.abort')
              }, _hoisted_19, 8, _hoisted_17)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", null, _toDisplayString(info.projectParticipation.comment), 1),
              (this.securityInfo.mayEditParticipation)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-sm btn-outline-primary ms-2",
                    onClick: ($event: any) => (_ctx.editComment(info)),
                    "data-bs-toggle": "tooltip",
                    title: _ctx.$t('general.edit')
                  }, _hoisted_23, 8, _hoisted_21))
                : _createCommentVNode("", true)
            ])),
        _createElementVNode("div", _hoisted_24, _toDisplayString(item.organisation.name), 1),
        _createElementVNode("div", _hoisted_25, _toDisplayString(rowPos.isFinished()), 1)
      ]),
      deputies: _withCtx(({ item, rowPos }) => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDeputyInfos(item, rowPos), (info) => {
              return (_openBlock(), _createElementBlock("div", {
                key: info.person.id,
                class: "d-flex flex-row flex-wrap gap-1 align-self-start"
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getDeputyString(info, item)), 1),
                _createElementVNode("div", _hoisted_28, [
                  (info?.organisationPerson?.emailAddress && this.securityInfo.mayEmailParticipation)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-sm btn-outline-secondary me-1",
                        disabled: this.disabled,
                        "data-bs-toggle": "tooltip",
                        title: _ctx.$t('project.participation.list.deputy.mail'),
                        onClick: ($event: any) => (_ctx.openEmailPage('organisationPerson', [info.organisationPerson.id]))
                      }, _hoisted_31, 8, _hoisted_29))
                    : _createCommentVNode("", true),
                  (this.securityInfo.mayShowPerson)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        disabled: this.disabled,
                        class: "btn btn-sm btn-outline-secondary me-1",
                        "data-bs-toggle": "tooltip",
                        title: _ctx.$t('project.participation.list.deputy.info'),
                        to: { name: 'personShow', params: { id: info.person.id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_32
                        ]),
                        _: 2
                      }, 1032, ["disabled", "title", "to"]))
                    : _createCommentVNode("", true),
                  (this.securityInfo.mayDeleteDeputy)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        disabled: this.disabled,
                        class: "btn btn-sm btn-outline-danger",
                        "data-bs-toggle": "tooltip",
                        title: _ctx.$t('project.participation.list.deputy.delete'),
                        onClick: ($event: any) => (this.deleteDeputy(info))
                      }, _hoisted_35, 8, _hoisted_33))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]),
          (!this.hasOwnParticipant(item.participationInfos[rowPos.getSubRow()]) && this.securityInfo.mayInsertMeAsDeputy)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-outline-primary",
                "data-bs-toggle": "tooltip",
                disabled: this.disabled,
                title: _ctx.$t('project.participation.list.deputy.addSelf'),
                onClick: (() => {
                            let participationInfo = item.participationInfos[rowPos.getSubRow()];
                            return () => _ctx.addMeAsDeputy(participationInfo);
                            })()
              }, _hoisted_38, 8, _hoisted_36))
            : _createCommentVNode("", true),
          (this.securityInfo.mayInsertMeAsDeputy)
            ? (_openBlock(), _createBlock(_component_DeputyAddDropdown, {
                key: 1,
                disabled: this.disabled,
                item: item,
                rowPos: rowPos,
                participationInfo: this.getParticipationInfo(item, rowPos),
                personInfos: this.personInfos
              }, null, 8, ["disabled", "item", "rowPos", "participationInfo", "personInfos"]))
            : _createCommentVNode("", true)
        ])
      ]),
      mainParticipant: _withCtx(({ item, rowPos, info = _ctx.getMainParticipantInfo(item, rowPos) }) => [
        (info != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("span", null, _toDisplayString(info.person.surName) + " " + _toDisplayString(info.person.givenName), 1),
              _createElementVNode("div", _hoisted_40, [
                (info?.organisationPerson?.emailAddress && this.securityInfo.mayEmailParticipation)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      disabled: this.disabled,
                      class: "btn btn-sm btn-outline-secondary me-1",
                      "data-bs-toggle": "tooltip",
                      title: _ctx.$t('project.participation.list.mainParticipant.mail'),
                      onClick: ($event: any) => (_ctx.openEmailPage('organisationPerson', [info?.organisationPerson?.id]))
                    }, _hoisted_43, 8, _hoisted_41))
                  : _createCommentVNode("", true),
                (this.securityInfo.mayShowPerson)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      disabled: this.disabled,
                      class: "btn btn-sm btn-outline-secondary",
                      "data-bs-toggle": "tooltip",
                      title: _ctx.$t('project.participation.list.mainParticipant.info'),
                      to: { name: 'personShow', params: { id: info.person.id } }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_44
                      ]),
                      _: 2
                    }, 1032, ["disabled", "title", "to"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t('project.participation.list.mainParticipant.missing')), 1)
            ]))
      ]),
      roles: _withCtx(({ item, rowPos }) => [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("span", null, _toDisplayString(_ctx.getRole(item, rowPos).name), 1),
          _createElementVNode("div", _hoisted_48, [
            (this.securityInfo.mayShowHistory)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary me-1",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.participation.list.organisation.showHistory'),
                  onClick: (() => {
                            let participation = item.participationInfos[rowPos.getSubRow()]?.projectParticipation;
                            let role = item.participationInfos[rowPos.getSubRow()]?.cdesRole?.name;
                            let organisation = item.organisation?.name;
                            
                            return () => {
                            this.history.participation = participation;
                            this.history.role = role;
                            this.history.organisation = organisation;
                            this.openHistoryDialog();
                            };
                            })()
                }, _hoisted_51, 8, _hoisted_49))
              : _createCommentVNode("", true),
            (this.securityInfo.mayEmailParticipation)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-secondary me-1",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.participation.list.role.mail'),
                  onClick: (() => {
                            let participation = item.participationInfos[rowPos.getSubRow()]?.projectParticipation;
                            return () => _ctx.openEmailPage('participation', [participation.id]);
                            })()
                }, _hoisted_54, 8, _hoisted_52))
              : _createCommentVNode("", true),
            (this.securityInfo.mayDeleteParticipation)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  disabled: this.disabled,
                  class: "btn btn-sm btn-outline-danger",
                  "data-bs-toggle": "tooltip",
                  title: _ctx.$t('project.participation.list.role.delete'),
                  onClick: (() => {
                            let participationInfo = item.participationInfos[rowPos.getSubRow()];
                            return () => _ctx.deleteParticipationById(item, participationInfo);
                            })()
                }, _hoisted_57, 8, _hoisted_55))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["columns", "rowPosFactory", "rowPosIncrementor", "items", "filterString", "idGetter"]),
    _createVNode(_component_Dialog, {
      ref: "historyDialog",
      buttons: _ctx.CLOSE,
      title: _ctx.$t('project.participation.list.participantHistory.dialogTitle', {organisation: this.history.organisation, role: this.history.role}),
      extraClasses: ['d-flex', 'justify-content-center', 'modal-xl', 'modal-dialog-centered']
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_ProjectParticipantHistoryPartListWidget, {
            items: this.history.participationParts
          }, null, 8, ["items"])
        ])
      ]),
      _: 1
    }, 8, ["buttons", "title"]),
    _createVNode(_component_Dialog, {
      ref: "deleteDialog",
      title: _ctx.$t('project.participation.list.delete.dialogCaption'),
      extraClasses: ['d-flex', 'justify-content-center', 'modal-xl', 'modal-dialog-centered']
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_ParticipationDeleteWidget, {
            deleteInfo: this.deleteInfo,
            onDoClose: _ctx.closeDeleteDialog,
            onRemoveParticipation: _ctx.removeParticipation
          }, null, 8, ["deleteInfo", "onDoClose", "onRemoveParticipation"])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}